import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatIconButton } from '@angular/material/button';

import { MAT_DIALOG_DATA, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { Map, ScanEventIssue } from '@ng-cloud/badger-core';
import { StartCasePipe } from '@ng-cloud/badger-core/common/pipes/start-case.pipe';
import { LayoutAlignDirective, LayoutDirective } from '@ngbracket/ngx-layout/flex';
import { IssueMapComponent } from '../issue-map/issue-map.component';

@Component({
  selector: 'bt-issue-map-dialog',
  templateUrl: './issue-map-dialog.component.html',
  styleUrls: ['./issue-map-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    IssueMapComponent,
    LayoutAlignDirective,
    LayoutDirective,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
    MatIcon,
    MatIconButton,
    StartCasePipe
  ]
})
export class IssueMapDialogComponent {
  title: string;
  size: string;
  storeMap: Map;
  scanEventIssue: ScanEventIssue;

  constructor(
    public dialogRef: MatDialogRef<IssueMapDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.title = data.title;
    this.storeMap = data.storeMap;
    this.scanEventIssue = data.scanEventIssue;
    this.size = data.size;
  }
}
